import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import { clickStreamUser, SessionKeys } from "../../utils/AppUtils";
import { learningPoints } from "../../redux/Cart/actions";
import {
  getLeaderBoardReq,
  // getReportListReq
} from "../../redux/user/actions";
import ContentLoader from "react-content-loader";
import ShimmerScreen from "../Layouts/ShimmerScreen";
import {
  deleteSavedFilterData,
  getSavedFilterData,
  getSavedFilterDataResponse,
} from "../../redux/reports/actions";
import LeaderBoardHomeComp from "../leaderboardComp/LeaderboardHomeComp";
import "./MyDashboardSectionManager.scss";
import { useTranslation } from "react-i18next";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import 'react-circular-progressbar/dist/styles.css';


const ActivityRing = ({ value, pathColor, trailColor, size,margin }) => (
  <div
    style={{
      position: "absolute",
      width: size,
      height: size,
      marginTop: margin,
      marginLeft: margin,
    }}
  >
    <CircularProgressbar
      value={value}
      strokeWidth={10}
      styles={buildStyles({
        pathColor,
        trailColor,
        strokeLinecap: "round",
        rotation: 0.25, // starts at top-right
      })}
    />
  </div>
);

const MyDashboardSectionManager = ({ auth, setIsLoading }) => {
  const isPremiumUser = useSelector((state) => state.user.isPremiumUser);
  const authBroker = useSelector((state) => state.auth.authBroker);
  const userDetailRes = useSelector((state) => state.user.userBroker);
  const [totalLearningPoints, setTotalLearningPoints] = useState(null);
  const coursesListingData = useSelector(
    (state) => state.courses.coursesListing
  );
  const myLearningPointsRes = useSelector(
    (state) => state.carts?.learningPoints
  );
  const leaderBoardDataTestRes = useSelector((state) => state.user.leaderBoard);
  const reportListForHomeRes = useSelector(
    (state) => state.user.reportListForHome
  );
  const userRole = useSelector((state) => state.user.role);
  const [learningPoint, setLearningPoints] = useState([]);
  const [overAllRank, setOverAllRank] = useState("");
  const [showRank, setShowRank] = useState(true);
  const [name, setName] = useState("");
  const [degn, setDegn] = useState("");
  const [totalAgents, setTotalAgents] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {t} = useTranslation();
  const [reportDataList, setReportDataList] = useState([]);
  const [isGuest,setIsGuest] = useState(false);
    useEffect(() => {
        if (!_.isEmpty(authBroker)) {
            if (authBroker.payload.user.role.includes('guest')) {
                setIsGuest(true);
            }
        }
    }, [authBroker])

  const savedFiltersDataResponse = useSelector(
    (state) => state.report.savedFilterDataRes
  );

  const deletedFiltersDataResponse = useSelector(
    (state) => state.report.deleteSavedFilterData
  );
  console.log("payl- del--", deletedFiltersDataResponse);
  console.log(
    "sa---",
    savedFiltersDataResponse,
    savedFiltersDataResponse?.payload?.payload
  );
  const [savedFiltersList, setSavedFiltersList] = useState([]);

  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
      dispatch(
        learningPoints({
          module: "learning-points/points",
          email: authBroker.payload.user.email,
        })
      );
      setName(
        `${authBroker.payload.user.firstname} ${authBroker.payload.user.lastname}`
      );
    }
    dispatch(
      getLeaderBoardReq({
        module: "leaderBoard",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          user_id: localStorage.getItem(SessionKeys.USER_ID),
        },
      })
    );
    // dispatch(
    //   getReportListReq({
    //     module: "reportListForHome",
    //     postData: {
    //       token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
    //     },
    //   })
    // );
  }, [dispatch, authBroker]);

  useEffect(() => {
    if (!_.isEmpty(reportListForHomeRes)) {
      console.log("reportListForHomeRes: ", reportListForHomeRes);
      if (reportListForHomeRes?.status === "success") {
        let reportData = reportListForHomeRes?.payload?.payload;
        setReportDataList(reportData);
      }
    }
  }, [reportListForHomeRes]);

  useEffect(() => {
    if (!_.isEmpty(savedFiltersDataResponse)) {
      if (savedFiltersDataResponse?.status === "success") {
        setSavedFiltersList(savedFiltersDataResponse?.payload?.payload);
        setIsLoading(false);
      } else {
        setSavedFiltersList([]);
        setIsLoading(false);
      }
    }
  }, [savedFiltersDataResponse]);

  const getFiltersFunc = () => {
    setIsLoading(true);
    dispatch(
      getSavedFilterData({
        module: "getSavedFiltersData",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        },
      })
    );
  };
  useEffect(() => {
    getFiltersFunc();
  }, []);

  useEffect(() => {
    // console.log('overAllRankRes', leaderBoardDataTestRes);
    if (!_.isEmpty(leaderBoardDataTestRes)) {
      if (leaderBoardDataTestRes?.status === "success") {
        let data = leaderBoardDataTestRes?.payload?.payload;
        if (!_.isEmpty(data)) {
          setOverAllRank(data?.current_rank);
          setTotalAgents(data?.total_agents)
          // for (const item of data.list) {
          //   if(item?.is_me){
          //     setOverAllRank(item.rank)
          //   }
          // }
          if(_.isEmpty(data?.current_rank)){
            setShowRank(false);
          }
        }
      } else {
        setOverAllRank("");
        setShowRank(false);
      }
    }
  }, [leaderBoardDataTestRes]);

  useEffect(() => {
    if (!_.isEmpty(userDetailRes)) {
      const userData = userDetailRes?.payload?.payload;
      const authUserData = auth?.authBroker?.payload?.user;
      if (!_.isEmpty(userData)) {
        let designation = "";
        if (userData.degn) {
          designation = designation + userData.degn;
        }
        if (userData.degn && authUserData.city) {
          designation = designation + ", ";
        }
        if (authUserData.city) {
          designation = designation + authUserData.city;
        }
        if (authUserData.city && authUserData.state) {
          designation = designation + ", ";
        }
        if (authUserData.state) {
          designation = designation + authUserData.state;
        }
        setDegn(designation);
      }
    }
  }, [userDetailRes]);

  const toInt = (value) => {
    if (value === null) {
      return 0;
    } else return parseInt(value);
  };

  useEffect(() => {
    // console.log('learningpoint', myLearningPointsRes)
    if (myLearningPointsRes?.status === "success") {
      var lpArray = myLearningPointsRes?.payload;
      let totalPoint = 0;
      if (!_.isEmpty(lpArray)) {
        if (_.isArray(lpArray) && lpArray.length > 0) {
          totalPoint = 0;
          for (let learningPoint of lpArray) {
            totalPoint = totalPoint + _.toNumber(learningPoint.point);
          }
        }
        myLearningPointsRes.payload = lpArray;
      }
      setShowRank(totalPoint != 0);
      setTotalLearningPoints(totalPoint);
    }
  }, [myLearningPointsRes]);

  // const navigateToReport = (id) => {
  //   switch (id) {
  //     case 1:
  //       navigate("/compliance-report");
  //       break;
  //     case 2:
  //       navigate("/lp-report?isCompliance=1");
  //       break;
  //     case 3:
  //       navigate("/lp-report?isCompliance=0");
  //       break;
  //     case 4:
  //       navigate("/compliance-report?isCompliance=0");
  //       break;
  //     case 5:
  //       navigate("/codeofethics-report");
  //       break;
  //     case 6:
  //       navigate("/systemusage-report");
  //       break;

  //     default:
  //       break;
  //   }
  // };

  const navigateToReport = (item) => {
    console.log("type--", item?.report_type, item);
    //localStorage.setItem("SELECTED_FILTERS",item?.filter_content); // setting selected filters to localStorage
    // switch (item?.report_type) {
    //   case "compliance":
    //     navigate(`/compliance-report?filters_id=${item?.id}`);
    //     break;
    //   case "onboarding":
    //     navigate(`/lp-report?isCompliance=1&filters_id=${item?.id}`);
    //     break;
    //   case "learning_path":
    //     navigate(`/lp-report?isCompliance=0&filters_id=${item?.id}`);
    //     break;
    //   case "learning_progress":
    //     navigate(`/compliance-report?isCompliance=0&filters_id=${item?.id}`);
    //     break;
    //   case "code_of_ethics":
    //     navigate(`/codeofethics-report?filters_id=${item?.id}`);
    //     break;
    //   case "system_usage_report":
    //     navigate(`/systemusage-report?filters_id=${item?.id}`);
    //     break;
    //   default:
    //     break;
    // }
    navigate(`/report?filters_id=${item?.id}&report_type=${item?.report_type}`);
  };

  const [isApiCalled, setIsApiCalled] = useState(false);
  const deleteFilter = (item) => {
    setIsLoading(true);
    dispatch(
      deleteSavedFilterData({
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          id: item?.id,
        },
      })
    );
  };
  const [formError, setFormError] = useState("");

  useEffect(() => {
    if (!_.isEmpty(deletedFiltersDataResponse) && isApiCalled) {
      if (deletedFiltersDataResponse?.status === "success") {
        getFiltersFunc();
      } else {
        setFormError("Failed to delete, try again!");
        setTimeout(() => {
          setFormError("");
        }, 3000);
        setIsLoading(false);
      }
    }
  }, [deletedFiltersDataResponse]);

  

const rings = [
    {
      value: 50,
      pathColor: "#FF6B00",
      trailColor: "#FFD5B0",
      size: 160,
      margin:0,
    },
    {
      value: 50,
      pathColor: "#007AFF",
      trailColor: "#B3D9FF",
      size: 120,
      margin:20,
    },
    {
      value: 60,
      pathColor: "#AF52DE",
      trailColor: "#E3C6FA",
      size: 90,
      margin:35,
    }
  ];

  return (
  true?<div
      style={{
        position: "relative",
        width: 160,
        height: 160,
      }}
    >
      {rings.map((ring, index) => (
        <ActivityRing key={index} {...ring} />
      ))}
    </div>:  <>
      {localStorage.getItem(SessionKeys.SHOW_LEADERBOARD) !== "false" && <div className="row align-items-start">
        <div className="col-lg-6 col-md-6">
          <div className="manager-info-updatebox">
            <div className="d-flex My_Dashboard New_My_Dashboard icon_MY_DB">
              <h3 className="mb-4">{t('myPerformance')}</h3>
              {/* <a
              onClick={() => {
                navigate("/profile/edit?section=dashboard");
                clickStreamUser("home-page-dashboard-hyperlink-clicked", {
                  userId: authBroker?.payload?.user.user_id,
                });
              }}
            >
              <button className="button-reset">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  id="Expand"
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                >
                  <defs>
                    <linearGradient
                      id="linear-gradient"
                      y1="0.5"
                      x2="1"
                      y2="0.5"
                      gradientUnits="objectBoundingBox"
                    >
                      <stop offset="0" stopColor="#415385" />
                      <stop offset="1" stopColor="#415385" />
                    </linearGradient>
                  </defs>
                  <circle
                    id="Ellipse_57"
                    data-name="Ellipse 57"
                    cx="15"
                    cy="15"
                    r="15"
                    fill="url(#linear-gradient)"
                  />
                  <circle
                    id="Ellipse_179"
                    data-name="Ellipse 179"
                    cx="13"
                    cy="13"
                    r="13"
                    transform="translate(2 2)"
                    fill="#fff"
                  />
                  <g
                    id="Group_1344"
                    data-name="Group 1344"
                    transform="translate(-525.5 -568.5)"
                  >
                    <path
                      id="Path_415"
                      data-name="Path 415"
                      d="M0,8H8V0"
                      transform="translate(536.5 587.5) rotate(-90)"
                      fill="none"
                      stroke="#415385"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="4"
                    />
                    <line
                      id="Line_51"
                      data-name="Line 51"
                      x1="7"
                      y2="7"
                      transform="translate(536.5 580.5)"
                      fill="none"
                      stroke="#415385"
                      strokeLinecap="round"
                      strokeWidth="4"
                    />
                  </g>
                </svg>
              </button>
            </a> */}
            </div>
            <h6 className="text_Dashboard">
              {
                name ? (
                  name
                ) : (
                  <ShimmerScreen
                    width={"3rem"}
                    height={"1.5rem"}
                    case={"rect"}
                  />
                )
                // <div className="skeleton-len" style={{width: '3rem', height:'1.5rem'}}></div>
                // <div className="skeleton-loader">
                //     <ContentLoader
                //     speed={2}
                //     width={200}
                //     height={60}
                //     viewBox="0 0 200 60">
                //         <rect x="0" y="0" rx="3" ry="3" width="100%" height="100%" />
                //     </ContentLoader>
                // </div>
              }
            </h6>
            <p className="paraGraph_Dashboard">
               {
              degn ? (
                degn
              ) :isGuest?"": (
                <ShimmerScreen
                  width={"25rem"}
                  height={"1.2rem"}
                  case={"rect"}
                />
              )
              
            } 
            </p>
            {coursesListingData.courseList &&
              coursesListingData.courseList?.length > 0}
            <div className="container-chart">
              <div className="box">
                <div
                  className="firstsecd d-flex flex-column gap-3"
                  data-percent="60"
                  data-scale-color="#FF6C02"
                >
                  <img src="/images/IconwithCircles.svg" />

                  <div
                    className="progress__txtBar mt-top cursor-pointer"
                    onClick={() => {
                      navigate("/learning-points");
                      clickStreamUser("home-page-learningpoint-clicked", {
                        userId: authBroker?.payload?.user.user_id,
                      });
                    }}
                  >
                    {totalLearningPoints !== null ? (
                      <>
                        <h3>{totalLearningPoints}</h3>
                      </>
                    ) : (
                      <div className="skeleton-loader">
                        <ContentLoader
                          speed={2}
                          width={52}
                          height={50}
                          viewBox="0 0 62 70"
                        >
                          <rect
                            x="0"
                            y="0"
                            rx="3"
                            ry="3"
                            width="51"
                            height="50"
                          />
                        </ContentLoader>
                      </div>
                    )}
                    <p>{t("Learning Points")}</p>
                  </div>
                </div>
              </div>

              {showRank && userRole !== "manager" && !isGuest ? (
                <div className="box box-2">
                  <div
                    className="firstsecd d-flex flex-column gap-3"
                    data-percent="25"
                    data-scale-color="#00B70E"
                  >
                    <img src="/images/IconwithCircles1.svg" />
                    <div className="progress__txtBarRS">
                      {overAllRank ? (
                        <>
                          {/* <p className="circle-2"></p> */}
                          <h3>
                            {overAllRank} <small>/{totalAgents} Agents</small>
                          </h3>
                          <p>Last Month Rank</p>
                        </>
                      ) : (
                        <div className="skeleton-loader">
                          <ContentLoader
                            speed={2}
                            width={90}
                            height={65}
                            viewBox="0 0 82 100"
                          >
                            <rect
                              x="0"
                              y="0"
                              rx="3"
                              ry="3"
                              width="21"
                              height="15"
                            />
                            <rect
                              x="0"
                              y="18"
                              rx="3"
                              ry="3"
                              width="51"
                              height="50"
                            />
                            <rect
                              x="0"
                              y="70"
                              rx="3"
                              ry="3"
                              width="81"
                              height="25"
                            />
                          </ContentLoader>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ) : true?
               <div style={{ position: 'relative', width: 180, height: 180 }}>
      {rings.map((ring, i) => (
        <ActivityRing key={i} {...ring} />
      ))}
    </div> :(
                 <div className="img-gra">
                    <img src="/images/graph.svg" alt="graph"/>
                </div>
              )}
            </div>
          </div>
        </div> 
        {authBroker.payload?.user.leaderboard_display === "yes" && <LeaderBoardHomeComp />}
        {/*<div className="col-lg-8 col-md-6 user-details-view manager-reports-home">
          <h4 className="teile-quick mb-3">Quick Report Links</h4>
          <div className="mb-2 login-msg">
          {formError ? (
            <div className="notmsg" style={{ color: "red" }}>
              {formError}
            </div>
          ) : (
            ""
          )}
          </div>
          <div className="row g-3">
            <div className="col-lg-4 col-md-6 col-12">
              <button
                className="report-g-btn btn-primary"
                onClick={() => {
                  navigate("/report?fromdashboard=true&report_type=compliance");
                }}
              >
                <span className="count-show"></span>
                Compliance
              </button>
            </div>
            <div className="col-lg-4 col-md-6 col-12">
              <button
                className="report-g-btn btn-primary"
                onClick={() => {
                  navigate("/report?fromdashboard=true&report_type=onboarding");
                }}
              >
                <span className="count-show"></span>
                Onboarding
              </button>
            </div>
            {savedFiltersList?.map((item, index) => {
              // if (index <= 5 && item?.title) {
              return (
                <div className="col-lg-4 col-md-6 col-12">
                  <button
                    className="report-g-btn btn-primary"
                    onClick={() => {
                      navigateToReport(item);
                    }}
                  >
                    <span className="count-show"></span>
                    {item?.title}
                    <span
                      className="cross-tab"
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsApiCalled(true);
                        deleteFilter(item);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 12 12"
                        fill="none"
                      >
                        <path
                          d="M7.5 2.5L2.5 7.5M2.5 2.5L7.5 7.5"
                          stroke="#000000"
                          strokeWidth="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          transform="translate(1 1)"
                        />
                      </svg>
                    </span>
                  </button>
                </div>
              );
              // }
            })}
            <div className="col-lg-4 col-md-6 col-12">
              <button
                className="report-g-btn btn-primary"
                onClick={() => {
                  navigate("/report");
                }}
              >
                <span className="count-show"></span>+ Add Report
              </button>
            </div>
          </div>
        </div>*/}
      </div>}
      {/* {userRole === "manager" && localStorage.getItem(SessionKeys.SHOW_LEADERBOARD) !== "false" && <div id="idMarketingCalendar" className="center_line mt-5 mb-5"></div>} */}
      {userRole=== "manager" && 
       
        <div className="user-details-view manager-reports-home pt-5g">
          <h4 className="teile-quick mb-4">{t('quickReportLinks')}</h4>
          {formError ? (
            <div className="notmsg" style={{ color: "red" }}>
              {formError}
            </div>
          ) : (
            ""
          )}
          <div className="row g-3">
            <div className="col-lg-4 col-md-6 col-12">
              <button
                className="report-g-btn btn-primary"
                onClick={() => {
                  navigate("/report?fromdashboard=true&report_type=compliance");
                }}
              >
                <span className="count-show"></span>
                {t("Compliance")}
              </button>
            </div>
            <div className="col-lg-4 col-md-6 col-12">
              <button
                className="report-g-btn btn-primary"
                onClick={() => {
                  navigate("/report?fromdashboard=true&report_type=onboarding");
                }}
              >
                <span className="count-show"></span>
                {t("Onboarding")}
              </button>
            </div>
            {savedFiltersList?.map((item, index) => {
              // if (index <= 5 && item?.title) {
              return (
                <div className="col-lg-4 col-md-6 col-12">
                  <button
                    className="report-g-btn btn-primary"
                    onClick={() => {
                      navigateToReport(item);
                    }}
                  >
                    <span className="count-show"></span>
                    {item?.title}
                    <span
                      className="cross-tab"
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsApiCalled(true);
                        deleteFilter(item);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                      >
                        <path
                          d="M7.5 2.5L2.5 7.5M2.5 2.5L7.5 7.5"
                          stroke="#000000"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          transform="translate(1 1)"
                        />
                      </svg>
                    </span>
                  </button>
                </div>
              );
              // }
            })}
            <div className="col-lg-4 col-md-6 col-12">
              <button
                className="report-g-btn btn-primary"
                onClick={() => {
                  navigate("/report");
                }}
              >
                <span className="count-show"></span>+ {t("Add Report")}
              </button>
            </div>
          </div>
        
        </div>
     }
    </>
  );
};

export default MyDashboardSectionManager;
